import { ITypedStock, OmniaObjectType, StockType } from "../omnia"

export function getStockActivity(create: boolean, stock: Partial<ITypedStock>, stockType: StockType) {

    const { id, resourceType } = getStockTypeInfo(stockType)

    return {
        action: create ? "c" : "u",
        resourceId: stock?.StockId ? `${id}:${stock.StockId}` : undefined,
        resourceType,
        year: stock?.YearId,
        data: {
            Name: stock?.Name
        }
    }


}

function getStockTypeInfo(type: StockType) {

    switch (type) {

        case StockType.Seed:
            return { id: "s", resourceType: OmniaObjectType.SeedStock }

        case StockType.Fertiliser:
            return { id: "f", resourceType: OmniaObjectType.FertiliserStock }

        case StockType.Manure:
            return { id: "m", resourceType: OmniaObjectType.ManureStock }

    }
}
